import { WS_SUBSCRIBE_EVENT, WS_UNSUBSCRIBE_EVENT } from 'constants/ActionTypes';

const INITIAL_STATE = {
  subscriptions: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WS_SUBSCRIBE_EVENT:
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          [action.payload.eventType]: [
            ...(state.subscriptions[action.payload.eventType] || []),
            action.payload.callback,
          ],
        },
      };
    case WS_UNSUBSCRIBE_EVENT:
      if (!state.subscriptions[action.payload.eventType]) {
        return state;
      }
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          [action.payload.eventType]: state.subscriptions[action.payload.eventType].filter(
            cb => cb !== action.payload.callback,
          ),
        },
      };
    default:
  }
  return state;
};
